import React, { useState } from "react";
import "../../css/LoginRecovery.css";
import { Link } from "react-router-dom";
import logo from "../../assets/cargotool.png";
import Button from "../../components/input/Button";

const OTPForm = ({ onNext, email }) => {
  const [otp, setOTP] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    // For simplicity, hardcoding the correct OTP. In a real application, this should be generated and sent to the user's email.
    const correctOTP = "123456";

    if (otp === correctOTP) {
      onNext(email);
    } else {
      alert("Invalid OTP. Please try again."); // Replace with proper error handling
    }
  };

  return (
    <div>
      <form className="otp-form" onSubmit={handleSubmit}>
        <img
          src={logo}
          style={{
            width: "200px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "auto",
          }}
          alt="logo"
        />
        <h1 className="title">Password Recovery</h1>
        <p>Enter the OTP sent to your email.</p>
        <input
          type="number"
          value={otp}
          placeholder={"XXXXXX"}
          onChange={(e) => setOTP(e.target.value)}
          maxLength={6}
        />
        <Button className="next-btn" type="submit" label="Next" />
      </form>
      <Link to={"/login"} className="back-btn">
        Back to Login
      </Link>
    </div>
  );
};

export default OTPForm;
